import "./i18n";
import './styles/index.css';

import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
// import AppRoutes from './routes/AppRoutes';
import { BrowserRouter } from "react-router-dom";
import App from "./App";


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      {/* <AppRoutes /> */}
      <App />
    </BrowserRouter>
  </React.StrictMode>
);


reportWebVitals();
